// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"7eda093d9614198a250df03b4944be8a607925db"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.27";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from "@sentry/nextjs";
import { baseSentryConfig } from "./baseSentryConfig";

// don't use sentry locally
if (process.env.NEXT_PUBLIC_APP_ENV !== "local") {
  Sentry.init({
    ...baseSentryConfig,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Only record a replay when an error actually occurs - no overhead/cost
    // for normal sessions, but a visual reproduction whenever something breaks.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
